<div class="column">
  <app-property-search-filter></app-property-search-filter>
  <table mat-table class="full-width-table" matSort aria-label="Properties">
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Property ID</th>
      <td mat-cell *matCellDef="let row">{{row.id}}</td>
    </ng-container>
    <ng-container matColumnDef="rentalPropertyStreetAddress">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Property Address</th>
      <td mat-cell *matCellDef="let row">{{row.rentalPropertyStreetAddress}}</td>
    </ng-container>
    <ng-container matColumnDef="frequency">
      <th mat-header-cell *matHeaderCellDef>Filing Frequency</th>
      <td mat-cell *matCellDef="let row">{{row.frequency | frequency}}</td>
    </ng-container>
    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef>Rental Property Type</th>
      <td mat-cell *matCellDef="let row">{{row.propertyType | propertyType}}</td>
    </ng-container>
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td mat-cell *matCellDef="let row">
        <app-status-indicator [statusText]="row.status"></app-status-indicator>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="clickable"
        [routerLink]="['/app/search/property', row.id]"></tr>
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="displayedColumns.length">
        No data matching the filter.
      </td>
    </tr>
  </table>

  <mat-paginator #paginator
      [length]="dataSource.data.length"
      [pageIndex]="0"
      [pageSize]="10"
      [pageSizeOptions]="[5, 10, 20]"
      aria-label="Select page">
  </mat-paginator>
</div>
